<script lang="ts" setup>
  import CuratedDeals from "@/components/views/rewards/CuratedDeals.vue";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";

  const subscriptionFlowStore = useSubscriptionFlowStore();
</script>

<template>
  <div class="d-flex flex-column align-center text-center">
    <div class="title" style="line-height: 150%">
      {{ $t('welcome.reminder.title') }}
    </div>
    <div class="mt-6 subtitle">
      <span>{{ $t('welcome.reminder.subtitle') }}</span>
    </div>
  </div>
  <div class="content">
    <CuratedDeals :show-title="false" style="width:100%;"/>
    <div class="t-body-2 t-bold">
      <span>{{ $t('welcome.reminder.call-to-action') }}</span>
    </div>
    <v-btn
      class="mt-5"
      type="submit"
      color="primary"
      width="320"
      rounded="lg"
      @click="subscriptionFlowStore.advanceStep"
    >
      {{ $t('common.subscribe') }}
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
  .title {
    font-size: getFontSize('large-2');
    font-weight: getFontWeight('bold');
  }

  .subtitle {
    font-size: getFontSize('body-1');
  }

  .content {
    display: flex;
    font-size: 16px;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    padding-top: 2rem;
  }

  @media(max-width: breakpoint(md) - 1px) {
    .title {
      font-size: getFontSize('subtitle-1');
    }

    .subtitle {
      font-size: getFontSize('body-2');
    }
  }
</style>
